import request from './request'

// ==================== AI 技能（/api/ai/skills） ====================

/** 可见技能列表（公共区 + 我的；q 模糊搜索） */
export function getSkillList(q) {
  const params = q ? { q } : {}
  return request.get('/ai/skills', { params })
}

/** 创建个人技能 */
export function createSkill(data) {
  return request.post('/ai/skills', data)
}

/** 删除个人技能 */
export function deleteSkill(id) {
  return request.delete(`/ai/skills/${id}`)
}
